// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"19":"e08f11c5","113":"5b24a6eb","346":"15736429","460":"a3a221ac","672":"3e8513d8","703":"a1ddf729","732":"b40440a5","913":"cfcc29bd","916":"90e7e764","977":"48256598"}[chunkId] + ".chunk.js";
};